import PriceRangeFilter from "./pricerangefilter.js";
import SubSearchFilter from "./subsearchfilter.js";
import ProductQuantityFilter from "./productquantityfilter.js";
import ColorSelectorFilter from "./colorselectorfilter.js";
import FilterMenu from "./filtermenu.js";
import UpdateFilterUrl from "./updatefilterurl.js";
import FilterValues from "./filtervalues.js";
import { prodListValues } from './shared.js';

const clearAllFilters = document.getElementById('clearAllFilters');
const clearAllFiltersMobile = document.getElementById('clearAllFiltersMobile');
const list = document.getElementById('selectedFilterList');
const listMobile = document.getElementById('selectedFilterListMobile');
const filtersSelected = document.getElementById('filtersSelected');
const filtersSelectedMobile = document.getElementById('filtersSelectedMobile');
const viewMore = document.getElementById('ViewMoreSelectedFilters');

// manages area that displays which filters have been selected
class SelectedFilters {
    get selectedFilterList() { return list; }

    addToGroup(id, label) {
        var newDiv = this.createDiv('selected_' + id, label);

        if (listMobile.firstElementChild !== null) {
            viewMore.classList.remove('hide');
            if (viewMore.getAttribute('aria-expanded') === 'false') {
                listMobile.firstElementChild.classList.add('hide');
                listMobile.firstElementChild.classList.remove('displayFlex');
            }
        }

        if (listMobile.textContent.trim() === 'Please select a filter') {
            listMobile.textContent = '';
        }

        this.prepend(list, newDiv);

        // need to recreate div to append to other filter box
        newDiv = this.createDiv('selected_' + id, label);

        this.prepend(listMobile, newDiv);

        filtersSelected.classList.remove('hide');
        filtersSelectedMobile.classList.remove('hide');
        this.showClearAll(); // note: moving focus to top of page is disorienting for a11y users
    };

    prepend(list, child) {
        if (list.hasChildNodes()) {
            list.insertBefore(child, list.firstChild);
        } else {
            list.appendChild(child);
        }
    };

    createDiv(newId, filterName) {
        var newDiv = document.createElement('div');
        newDiv.classList.add(newId);
        newDiv.classList.add('selectedFilter', "displayFlex", "flexAlignItemsCenter", "flexSpaceBetween", "padding10", "text18");

        var filterDiv = '<p class="c-xs-quarter-3 noPadding" role="alert" aria-atomic="true"><span class="visually-hidden">Now Showing </span>' +
            filterName + '</p><button class="noLine darkestLink btnToHyp padding5 ' + newId + 
            '"> <svg class="show" height="20px" width="20px" aria-label="remove ' + filterName +
            ' filter" role="img"><title>Remove ' + filterName + ' filter</title><use href="/icons/iconLibrary.svg#svgIcon-remove"></use></svg></button>';
        
        newDiv.innerHTML = filterDiv;
        const button = newDiv.querySelector('button');
        
        button.addEventListener('click', () => this.removeFilterClick(newId));
        button.addEventListener('keypress', (e) => this.removeFilterKeypress(e, newId));
        return newDiv;
    };

    removeFilterClick(element) {
        var elementId = element.replace('selected_', '');

        if (elementId === 'PriceRange') {
            PriceRangeFilter.clear();
        } else if (elementId === 'txtInnerSearch') {
            SubSearchFilter.clear();
        } else if (elementId === 'txtProductQuantity') {
            ProductQuantityFilter.clear();
        } else if (FilterValues.isColorId(elementId)) {
            ColorSelectorFilter.remove(document.getElementById(elementId));
        } else {
            FilterMenu.markUnSelected(document.getElementById(elementId));
        }

        UpdateFilterUrl.update(FilterValues, prodListValues, false);

        return false;
    };

    removeFilterKeypress(e, element) {
        if (e.which === 13) {
            this.removeFilterClick(element);
        }
    };

    addToSelectedFilter(element, filterName) {
        if (filterName) {
            this.addToGroup(element.id, filterName);
        } else if (element.id.indexOf('ImprintLocation') !== -1) {
            this.addToGroup(element.id, document.getElementById('ImprintLocationCountFilterTitle').value.replace('##IMPLOC##', element.getAttribute('data-filter')));
        } else if (element.id.indexOf('ImprintColor') !== -1) {
            this.addToGroup(element.id, document.getElementById('ImprintColorCountFilterTitle').value.replace('##IMPCOLOR##', element.getAttribute('data-filter')));
        } else {
            var label = element.getAttribute('data-filter');
            this.addToGroup(element.id, label);
        }
    };

    resetViewMoreFilter() {
        var label = viewMore.innerHTML;
        if (viewMore.getAttribute('aria-expanded') === 'true') {
            viewMore.setAttribute('aria-expanded', 'false');
            label = "View All Selected";
            viewMore.innerHTML = label;
            viewMore.setAttribute("data-text", label);
        } else {
            viewMore.setAttribute('aria-expanded', 'true');
            label = "View Fewer Filters";
            viewMore.innerHTML = label;
            viewMore.setAttribute("data-text", label);
        }

        viewMore.classList.add('hide');
    };

    removeFromSelectedFilter(element) {
        // remove the div in selected filters
        var filterMobile = listMobile.querySelector('.selected_' + element.id);
        var filter = list.querySelector('.selected_' + element.id);

        if (filterMobile !== null) {
            if (listMobile.children.length > 1) {
                list.removeChild(filter);
                listMobile.removeChild(filterMobile);

                listMobile.firstElementChild.classList.remove('hide');

                if (listMobile.children.length === 1) {
                    this.resetViewMoreFilter();
                }
            } else {
                this.removeAllFromSelectedFilter();
            }
        }
    };

    removeAllFromSelectedFilter() {
        list.innerHTML = '';
        listMobile.innerHTML = 'Please select a filter';
        this.resetViewMoreFilter();
    };

    // Toggle the view more and less selected filters visibility and CSS to change the display.
    toggleSelectedFiltersView(e) {
        e.preventDefault();

        this.toggleSelectedFilterItems();
        var label = viewMore.innerHTML;
        if (viewMore.getAttribute('aria-expanded') === 'true') {
            viewMore.setAttribute('aria-expanded', 'false');
            label = "View All Selected";
            viewMore.innerHTML = label;
            viewMore.setAttribute("data-text", label);
        } else {
            viewMore.setAttribute('aria-expanded', 'true');
            label = "View Fewer Filters";
            viewMore.innerHTML = label;
            viewMore.setAttribute("data-text", label);
        }
    };

    toggleSelectedFilterItems() {
        for (var i = 1; i < listMobile.children.length; i++) {
            let item = listMobile.children[i];
            if (item.classList.contains("hide")) {
                item.classList.remove("hide");
            } else {
                item.classList.add("hide");
            }
            if (item.classList.contains("hide")) {
                item.classList.remove("displayFlex");
            } else {
                item.classList.add("displayFlex");
            }
        }
    };

    events() {
        clearAllFilters.addEventListener('click', (e) => {
            e.preventDefault();

            FilterMenu.unSelectAllFilters(true);
            this.hideClearAll();
        });

        clearAllFiltersMobile.addEventListener('click', (e) => {
            e.preventDefault();

            FilterMenu.unSelectAllFilters(true);
            this.hideClearAll();
        });

        viewMore.addEventListener('click', this.toggleSelectedFiltersView.bind(this));
    };

    hideClearAll() {
        clearAllFilters.classList.add('hide');
        clearAllFiltersMobile.classList.add('hide');
    };

    showClearAll() {
        clearAllFilters.classList.remove('hide');
        clearAllFiltersMobile.classList.remove('hide');
    };
}

export default new SelectedFilters();